import React, { useEffect, useState } from 'react';
import { AppCategory, getAppCategories } from 'app/console-api/apps/categories';
import { FlexColumn, FlexRow } from '@make-software/cspr-design';
import { AppCategoriesTypeControl } from 'app/components/management/apps/settings/categories/app-categories-type-control';
import styled from 'styled-components';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';
import { PageContainer } from 'app/components/common/common-styles';

const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    margin: ['48px 48px 48px 48px']
  })
);

export const AppCategoriesPage = () => {
  const { app } = useTabsCtx();
  const [categories, setCategories] = useState<AppCategory[]>([]);
  const { setBreadcrumbs } = useTabsCtx();

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: 'Edit Categories'
      }
    ]);
    return () => setBreadcrumbs([]);
  }, [app]);

  useEffect(() => {
    if (!app) return;
    getAppCategories(app.id)
      .then((response) => setCategories(response.data || []))
      .catch((error: any) => {
        console.error('Failed to fetch categories', error);
      });
  }, [app]);

  return (
    <PageContainer>
      <FlexRow justify={'center'} align={'center'}>
        <Container>
          <AppCategoriesTypeControl categories={categories} appID={app?.id || ''} />
        </Container>
      </FlexRow>
    </PageContainer>
  );
};
